import { createApi } from "./common";

const airlinesApi = createApi("/");

export const findAirlines = () =>
  airlinesApi
    .get("airlines_8c29abb3df41e6f6a2b34a.json")
    .then((airlines) => airlines.map((a) => ({ ...a, id: a.iata })));
